import { render, staticRenderFns } from "./PostFromOffice.vue?vue&type=template&id=311a8ccd&"
import script from "./PostFromOffice.vue?vue&type=script&lang=js&"
export * from "./PostFromOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports